import { createCrudSlice } from '../createCrudSlice';
import downloadsService from '@/services/downloads.service';

const { reducer, thunks } = createCrudSlice('downloads', downloadsService);
export const { fetchList: fetchDownloads, createItem: createDownload, updateItem: updateDownload, deleteItem: deleteDownload } = thunks;
export default reducer;
